<template>
    <v-container fluid class="pr-0 pl-0">
        <v-row column justify-center align-center>
            <v-col cols="12">
                <FormCatalogRequest />
                <v-progress-linear
                    v-show="loader"
                    indeterminate
                    color="primary"
                ></v-progress-linear>
            </v-col>
        </v-row>
    </v-container>
</template>
<script>
import FormCatalogRequest from '~/components/forms/FormCatalogRequest.vue'

export default {
    name: 'FormCatalog',
    components: {
        FormCatalogRequest,
    },
    data() {
        return {
            loader: false,
            tab: null,
            tabList: [
                { tab: 1, content: 'Download Catalog' },
                { tab: 2, content: 'Request Hard Copy & Download' },
            ],
        }
    },
    computed: {},
    methods: {
        applyLoader(event) {
            this.loader = event
        },
    },
}
</script>
